import Vue from 'vue';
import Vapi from "vuex-rest-api"
import Version from '@/models/Version';
import locales from '@/locales/index'
import Themes from '@/themes';
import AppEvents from '@/AppEvents';
import MovitInstanceConfig from '@/models/MovitInstanceConfig';

let themeId = "default";
if (document.location.host.indexOf("kovanen.") > -1) {
    themeId = "kovanen";
} else if (document.location.host.indexOf("espoonkaupunki.") > -1) {
    themeId = "espoo";
} else if (document.location.host.indexOf("jytaksi.") > -1) {
    themeId = "jytaksi";
}

let defaultLang = 'en';
if (document.location.host.endsWith(".fi")) {
    defaultLang = "fi";
}

const appApi = new Vapi(
    {
        baseURL: process.env.VUE_APP_API_HOST + "/api/app",
        state: {
            movitInstanceConfigs: [],
            themes: Themes.themes,
            themeId,
            online: true,
            localesLoaded: false,
            locale: null,
            translateMode: false,
            showExpiredTimetables: true,
            showOnlyMyTimetables: false,
            showTimetablesAsList: false,
            timetableListDataTablePagination: {
                sortBy: 'idNumber'
            },
            lastSelectedTimetableId: null,
            lastSelectedTimetableState: null,
            showExpiredBookings: true,
            showOnlyMyBookings: false,
            showBookingsAsList: false,
            lastSelectedBookingId: null,
            lastSelectedBookingState: null,
            bookingListDataTablePagination: {
                sortBy: 'startDate'
            },
            arrivalsDeparturesSelectedDateId: null, // moment(new Date()).startOf("day").format('YYYY-MM-DD'),
            version: new Version(require('@/../public/info.json').frontend.version),
            apiInfo: {},
            apiInfoPollingTimeoutMS: 10 * 60 * 1000,
            defaultLocale: defaultLang,
            supportedLocaleCodes: locales.map(l => l.code),
            timetable: {
                splitLimitDays: {
                    allowDaysBeforeEnd: 0,
                    allowDaysAfterStart: 0,
                    newStartMinDaysFromToday: 0
                }
            }
        }
    }
)
.get({
    action: "getApiInfo",
    property: "apiInfo",
    path: "/info"
})
.get({
    action: "getAllMovitInstanceConfigs",
    property: "movitInstanceConfigs",
    path: "/movitInstanceConfigs",
    onSuccess: (state, payload, axios) => {
      state.movitInstanceConfigs = payload.data.map(c => MovitInstanceConfig.fromApi(c));
    },
    onError: (state: any, error: any, axios: any) => {
        AppEvents.handleApiError(error);
    }
})

const appStore = appApi.getStore();
(appStore as any).namespaced = true;
(appStore as any).persist = [
    "themeId",
    "locale", 
    "translateMode", 
    "showExpiredTimetables", 
    "showOnlyMyTimetables",
    "showTimetablesAsList", 
    "lastSelectedTimetableState", 
    "timetableListDataTablePagination",    
    "showExpiredBookings", 
    "showOnlyMyBookings",
    "showBookingsAsList", 
    "lastSelectedBookingState", 
    "bookingListDataTablePagination",
    "arrivalsDeparturesSelectedDateId"
];

// loadLocales
appStore.actions.loadLocales = (context) => {
    try {
        for (const locale of locales){
            (Vue as any).i18n.add(locale.code, locale.translations);
        }
        context.commit( "localesLoaded", true);
    } catch (error) {
        console.error(error)
        context.commit("localesLoaded", false);
    } 
}
appStore.mutations.localesLoaded = (context, value) => {
    context.localesLoaded = value;
}

// setLocale
appStore.actions.setLocale = (context, value) => {
    context.commit("setLocale", value);
}
appStore.mutations.setLocale = (context, value) => {
    Vue.i18n.set(value)
    context.locale = value;
}

// setTranslateMode
appStore.actions.setTranslateMode = (context, value) => {
    context.commit( "setTranslateMode", value);
}
appStore.mutations.setTranslateMode = (context, value) => {
    context.translateMode = value;
}

// setThemeId
appStore.actions.setThemeId = (context, value) => {
    context.commit( "setThemeId", value);
}
appStore.mutations.setThemeId = (context, value) => {
    context.themeId = value;
}

// setShowExpiredTimetables
appStore.actions.setShowExpiredTimetables = (context, value) => {
    context.commit( "setShowExpiredTimetables", value);
}
appStore.mutations.setShowExpiredTimetables = (context, value) => {
    context.showExpiredTimetables = value;
}

// setShowOnlyMyTimetables
appStore.actions.setShowOnlyMyTimetables = (context, value) => {
    context.commit( "setShowOnlyMyTimetables", value);
}
appStore.mutations.setShowOnlyMyTimetables = (context, value) => {
    context.showOnlyMyTimetables = value;
}

// setShowTimetablesAsList
appStore.actions.setShowTimetablesAsList = (context, value) => {
    context.commit( "setShowTimetablesAsList", value);
}
appStore.mutations.setShowTimetablesAsList = (context, value) => {
    context.showTimetablesAsList = value;
}

// setTimetableListDataTablePagination
appStore.actions.setTimetableListDataTablePagination = (context, value) => {
    context.commit( "setTimetableListDataTablePagination", value);
}
appStore.mutations.setTimetableListDataTablePagination = (context, value) => {
    context.timetableListDataTablePagination = value;
}

// setLastSelectedTimetableId
appStore.actions.setLastSelectedTimetableId = (context, value) => {
    context.commit( "setLastSelectedTimetableId", value);
}
appStore.mutations.setLastSelectedTimetableId = (context, value) => {
    context.lastSelectedTimetableId = value;
}

// setLastSelectedTimetableState
appStore.actions.setLastSelectedTimetableState = (context, value) => {
    context.commit( "setLastSelectedTimetableState", value);
}
appStore.mutations.setLastSelectedTimetableState = (context, value) => {
    context.lastSelectedTimetableState = value;
}

// setShowExpiredBookings
appStore.actions.setShowExpiredBookings = (context, value) => {
    context.commit( "setShowExpiredBookings", value);
}
appStore.mutations.setShowExpiredBookings = (context, value) => {
    context.showExpiredBookings = value;
}

// setShowOnlyMyBookings
appStore.actions.setShowOnlyMyBookings = (context, value) => {
    context.commit( "setShowOnlyMyBookings", value);
}
appStore.mutations.setShowOnlyMyBookings = (context, value) => {
    context.showOnlyMyBookings = value;
}

// setShowBookingsAsList
appStore.actions.setShowBookingsAsList = (context, value) => {
    context.commit( "setShowBookingsAsList", value);
}
appStore.mutations.setShowBookingsAsList = (context, value) => {
    context.showBookingsAsList = value;
}

// setBookingListDataTablePagination
appStore.actions.setBookingListDataTablePagination = (context, value) => {
    context.commit( "setBookingListDataTablePagination", value);
}
appStore.mutations.setBookingListDataTablePagination = (context, value) => {
    context.bookingListDataTablePagination = value;
}

// setLastSelectedBookingId
appStore.actions.setLastSelectedBookingId = (context, value) => {
    context.commit( "setLastSelectedBookingId", value);
}
appStore.mutations.setLastSelectedBookingId = (context, value) => {
    context.lastSelectedBookingId = value;
}

// setLastSelectedBookingState
appStore.actions.setLastSelectedBookingState = (context, value) => {
    context.commit( "setLastSelectedBookingState", value);
}
appStore.mutations.setLastSelectedBookingState = (context, value) => {
    context.lastSelectedBookingState = value;
}

// // getters
// (appStore as any).getters = {
//     version: (context) => {
//         return context.version;
//     }
// };

export default appStore
